/* eslint-disable react/function-component-definition */
import React from 'react';

const Actors = () => {
  return (
    <div>Actors</div>
  );
};

export default Actors;
